<template>
	<div>
		<!-- <headers bg="#000" color="#fff"></headers> -->
		<headers></headers>
		<div class="cd-container py-5">
			<a-spin :spinning="loading">
				<div class="ftr-1-25 ftw600">
					{{$t('cashDesk.orderOverview')}}
				</div>
				<div class="row mt-3">
					<div class="cd-col-18">
						{{$t('userMyWallet.classNumber')}}
					</div>
					<div class="cd-col-15">
						{{$t('cashDesk.subject')}}
					</div>
					<div class="cd-col-15">
						{{$t('cashDesk.degree')}}
					</div>
					<div class="cd-col-15">
						{{$t('cashDesk.category')}}
					</div>
					<div class="cd-col-15">
						{{$t('cashDesk.time')}}
					</div>
					<div class=" cd-col-15">
						{{$t('cashDesk.classNum')}}
					</div>
					<div class="cd-col-15">
						{{$t('cashDesk.money')}}
					</div>
					<!-- <div class="cd-col-md">
						{{$t('common.delete')}}
					</div> -->
				</div>
				<div class="row mt-1 py-4 border-gray">
					<div class="cd-col-18">
						<div class="flex  alcenter">
							<img :src="teachercourse.photo_image" alt="" style="width: 60px;height: 60px;border-radius: 50%;" />
							<div class="ms-2">
								<div class="ft16 wid-fit text-over2">
									{{teachercourse.name}}
								</div>
								<div class="cl-theme">
									{{'生涯規劃認證老師'}}
								</div>
							</div>
							
						</div>
					</div>
					<div class="cd-col-15">
						<div class="border-gray br4 px-3 py-1 mt-2">
							{{course_name}}
						</div>
						
					</div>
					<div class="cd-col-15">
						<div class="border-gray br4 px-3 py-1 mt-2">
							{{course_classify_name}}
						</div>
					</div>
					<div class="cd-col-15">
						<div class=" br4 px-3 py-1 mt-2">
							{{is_test?$t('classManage.trialClass'):$t('becomeTeacher.formalClass')}}
						</div>
					</div>
					<div class="cd-col-15">
						<div class="border-gray br4 px-3 py-1 mt-2">
							{{is_test?'25':'50'}}分鐘
						</div>
					</div>
					<div class=" cd-col-15 pos-re">
						<div class="border-gray br4 text-center py-1 mt-2">
							{{teachercourse.quantity}}x {{getCurrency()}} {{convertCurrency( teachercourse.once_price) }}/堂
						</div>
						<!-- <div class="pos-ab ft14" style="bottom: -10px;right: 10px;">
							{{$t('cashDesk.single')}}{{getCurrency()}}{{is_test?convertCurrency( teachercourse.experience_price): convertCurrency(teachercourse.quantity_one_price)}}
						</div> -->
					</div>
					<div class="cd-col-15">
						<div class="">
							<div class="pb10 text-center">
								{{getCurrency()}}{{convertCurrency(total)}}
							</div>
							<!-- <div class="ft14 mt10">
								{{$t('cashDesk.discount')}}{{getCurrency()}}{{convertCurrency(discountAmount)}}
							</div> -->
						</div>
					</div>
					<!-- <div class="cd-col-md flex alcenter">
						<img src="../../assets/image/commom/delete-circle.png" alt="" />
					</div> -->
				</div>
				<div class="mt-4">
					{{$t('cashDesk.selectCoupon')}}
				</div>
				<div class="flex alcenter mt-3  py-2 px-2" style="background-color: #E8F7F8; height: 64px;">
					<img src="../../assets/image/forPay/coupon.png" alt="" class="mr10" style="width: 40px;height: 40px;" />
					<div style="width: 100px;font-size: 1rem;">
						{{$t('cashDesk.coupon')}}
					</div>
					<select class="form-select" v-model="coupon_id" @change="getCoupon"
					style="border: none;background-color: #E8F7F8;width: ;">
						<option :value="0">
							<!-- 沒有優惠券可以選擇 -->
							{{$t('cashDesk.noCoupon')}}
						</option>
						<option :value="item.id" v-for="(item,index) in couponList">{{item.name}}</option>
					</select>
				</div>
				
				<div class="mt-3 border-gray br8 py-2 px-2">
					<!-- 購買試堂抵扣 -->
					{{$t('cashDesk.couponDiscount')}} {{discountsUserInfo.initial_price? convertCurrency(discountsUserInfo.initial_price):'0.00'}}
				</div>
				<div class="mt-3 border-gray br8 py-2 px-2 d-flex justify-content-between">
					<div class="">
						{{$t('cashDesk.totalCount')}}
					</div>
					<div class="">
						{{getCurrency()}}{{convertCurrency(totalNum) }}
					</div>
				</div>
				<div class="mt-4">
					<!-- 支付方式 -->
					{{$t('cashDesk.paymentMethod')}}
				</div>
				<div class="mt-2">
					{{$t('cashDesk.payment')}}({{$t('cashDesk.balance')}} {{getCurrency()}}{{convertCurrency(userInfo.money)}})
				</div>
				<div class="mt-3 ftr-1-25">{{$t('cashDesk.enjoyProtection')}}</div>
				<div class="flex mt-3">
					<div class="btn border-theme p-2 flex alcenter" >
						<img src="../../assets/image/forPay/icon1.png" alt="" class="cashDesk-icon" />
						支付安全
					</div>
					<div class="btn border-theme p-2 ml16">
						<img src="../../assets/image/forPay/icon2.png" alt="" class="cashDesk-icon" />
						退課保障
					</div>
					<div class="btn border-theme p-2 ml16">
						<img src="../../assets/image/forPay/icon3.png" alt="" class="cashDesk-icon" />
						老師更換權
					</div>
					<div class="btn border-theme p-2 ml16">
						<img src="../../assets/image/forPay/icon4.png" alt="" class="cashDesk-icon" />
						學習報告
					</div>
					<div class="btn border-theme p-2 ml16">
						<img src="../../assets/image/forPay/icon5.png" alt="" class="cashDesk-icon" />
						課堂爭議仲裁
					</div>
					<div class="btn border-theme p-2 ml16">
						<img src="../../assets/image/forPay/icon6.png" alt="" class="cashDesk-icon" />
						老師質量監管
					</div>
				</div>
				<div class="mt-3 flex center">
					<button type="button" class="btn btn-theme mt-2" v-if="userInfo.money==0" @click="rechargeVisible = true">{{$t('cashDesk.noBalance')}}</button>
					
					<button type="button" class="btn btn-theme mt-2" v-else @click="createOrder">{{$t('cashDesk.pay')}}</button>
				</div>
				
			</a-spin>
			<div v-if="rechargeVisible">
				<recharge :visible="rechargeVisible" @cancel="handleCancel()" @okRecharge="okRecharge()"></recharge>
			</div>
		</div>
		<!-- 页脚 -->
		<footers></footers>
	</div>
</template>

<script>
	import recharge from '../../components/recharge.vue'
	export default{
		components:{
			recharge
		},
		data(){
			return{
				teachercourse:{
					id:0,
					name:'',
					photo_image:'',
					course_id:0,
					course_classify_id:0,
					quantity:0,//课程数量
					price:0,
					quantity_one_price:0,
				},
				course_name:'',
				course_classify_name:'',
				total:0,
				loading:false,
				rechargeVisible:false,
				is_test:false,
				couponList:[],
				coupon_id:0,
				couponInfo:{},//选择的优惠卷信息
				discountsUserInfo:{},//抵扣信息
				
				teacher_course_sale_id:0,//限时优惠课程包ID
			}
		},
		created(){
			let obj = this.$route.query,item = {}
			this.teachercourse.name = obj.teacherName
			this.teachercourse.photo_image = obj.teacherPhoto
			
			if(obj.teacher_course_sale_id){
				item = JSON.parse(obj.item)
				this.teacher_course_sale_id = obj.teacher_course_sale_id
				this.teachercourse.id = item.teacher_course_id
			}else{
				if(obj.test&&obj.test=='1'){
					this.is_test = true
					this.teachercourse.id = obj.teacher_course_id
					
				}else{
					this.is_test = false
					 item = JSON.parse(obj.item)
					this.teachercourse.id = item.id
				}
			}
			
			
			this.preOrder()
		},
		computed:{
			okRecharge(){
				this.$forceUpdate()
			},
			totalNum(){
				let num = this.total
				if(this.couponInfo.deduction_num){
					num = num - Number(this.couponInfo.deduction_num)
				}
				if(this.discountsUserInfo.initial_price){
					num = num -  Number(this.discountsUserInfo.initial_price)
				}
				return num<0?0:num
			},
			discountAmount(){
				let num = 0
				if(this.couponInfo.deduction_num){
					num = num +  Number(this.couponInfo.deduction_num)
				}
				if(this.discountsUserInfo.initial_price){
					num = num +  Number(this.discountsUserInfo.initial_price)
				}
				return num
			},
		},
		methods:{
			getCoupon(){
				this.couponList.forEach((item,index)=>{
					if(item.id==this.coupon_id){
						this.couponInfo = item
					}
				})
				if(this.coupon_id==0){
					this.couponInfo = {}
				}
			},
			handleCancel(){
				this.rechargeVisible = false
			},
			preOrder(){
				this.loading = true
				this.$http.api('order/preOrder',{
					teacher_course_id:this.teachercourse.id,
					teacher_course_sale_id:this.teacher_course_sale_id
				}).then(res=>{
					// this.createOrder()
					this.teachercourse = res.teacherCourse
					this.course_classify_name = res.teacherCourse.course_classify_name
					this.course_name = res.teacherCourse.course_name
					this.couponList = res.coupon
					if(this.couponList.length!=0){
						this.coupon_id = this.couponList[0].id
						this.couponList.forEach((item,index)=>{
							if(item.id==this.coupon_id){
								this.couponInfo = item
							}
						})
					}
					if(res.discountsUserCoursePackage.length!=0){
						this.discountsUserInfo = res.discountsUserCoursePackage[0]
					}
					// this.total = this.is_test? Number(this.teachercourse.experience_price): Number(this.teachercourse.price)
					this.total =  Number(this.teachercourse.price)
					this.loading = false
				}).catch(res=>{
					this.loading = false
				})
			},
			createOrder(){
				if(Number(this.convertCurrency(this.userInfo.money))< Number(this.convertCurrency(this.total))){
					// console.log(this.userInfo);
					this.rechargeVisible = true
					return
				}
				
				
				this.$confirm({
				    title: this.$t('common.confirmPayment'),
				    content: this.$t('cashDesk.pay'),
				    okText: this.$t('common.confirm'),
				    okType: "danger",
				    cancelText: this.$t('common.cancel'),
					okButtonProps: {
					    style: { backgroundColor: '#52C4C9',borderColor:'#52C4C9', color: 'white' } // 设置确认按钮颜色
					  },
				    onOk: () => {
				       this.$http.api('order/createOrder',{
				       	teacher_course_id:this.teachercourse.id,
				       	// order_type:this.is_test?1: 2,//订单类型 1=体验课 2=老师课程
						order_type:2,//订单类型 1=体验课 2=老师课程
				       	coupon_id:this.coupon_id,
				       	discounts_relevance_id:this.discountsUserInfo.id,
						teacher_course_sale_id:this.teacher_course_sale_id
				       }).then(res=>{
				       	if(res.is_zero!==1){
				       		this.orderPay(res.id)
				       	}
				       }).catch(res=>{
				       	this.loading = false
				       })
				    },
				    onCancel: () => {
				        console.log("Cancel");
				    },
				});
				
				
				
			},
			orderPay(id){
				this.$http.api('order/orderPay',{
					order_id:id,
					pay_type:1
				}).then(res=>{
					this.$message.success(this.$t('cashDesk.purchaseSuccessful'))
					this.loading = false
					this.$router.push('/students')
				})
			}
		}
	}
</script>

<style scoped>
	.cashDesk-icon{
		width: 20px;
		height: 20px;
		margin-right: 10px;
	}
	.cd-col-md {
	  flex: 1 0 0;
	}
	.cd-col-15{
		flex: 0 0 auto;
		width: 12%;
	}
	.cd-col-18{
		flex: 0 0 auto;
		width: 18%;
	}
	@media (max-width:575.98px) {
		.p-6 {
			padding-left: 1.5rem !important;
			padding-right: 1.5rem !important;
		}
		.cd-container {
			margin: auto;
			width: 100%;
			padding-left: 1.5rem !important;
			padding-right: 1.5rem !important;
		}
		
	}
	@media (min-width: 576px) {
		.cd-container {
			margin: auto;
			width: 580px;
		}
	
	}
	
	@media (min-width: 768px) {
		.cd-container {
			margin: auto;
			width: 700px;
		}
	}
	@media (min-width: 992px) {
		.cd-container {
			margin: auto;
			width: 900px;
		}
	}
	@media (min-width: 1200px) {
		.cd-container {
			margin: auto;
			width: 1100px;
		}
	}
	
	@media (min-width: 1400px) {
		.cd-container {
			margin: auto;
			width: 1300px;
		}
	}
</style>